<div class="screen-container">
  <app-card [title]="'tmidentify.title' | translate">
    <div left-content>

      <span
        *ngIf="isLoading"
        class="icon icon-loading"
      ></span>

      <div class="text-container" *ngIf="!isLoading">

        <ng-container *ngIf="presentableClientData$ | async as lead">
          <div *ngIf="success && !error; else abortedBlock" class="application-data">

            <p class="key">{{ 'tmidentify.amount' | translate }}</p>
            <p class="value">{{ lead.amount | myCurrency }}</p>
  
            <p class="key">{{ 'tmidentify.duration' | translate }}</p>
            <p class="value">{{ lead.duration | duration: translateService.instant('global.yearLabel') : translateService.instant('global.monthLabel') }}</p>
            
            <p class="key">{{ 'tmidentify.companyName' | translate }}</p>
            <p class="value">{{ lead.companyName }}</p>
    
            <p class="key">{{ 'tmidentify.email' | translate }}</p>
            <p class="value">{{ lead.email }}</p>
    
            <p class="key">{{ 'tmidentify.phoneNumber' | translate }}</p>
            <p class="value">{{ lead.phoneNumber }}</p>
            
            <p class="key">{{ 'tmidentify.reason' | translate }}</p>
            <p class="value">{{ lead.reason }}</p>
          
            <div actions class="navigationButtons">
              <app-deeplink-button
                (buttonClicked)="buttonNext()"
                mat-flat-button
                [text]="'tmidentify.nextButtonText'"
                [fullWidth]="true"
                [icon]="'none'"
              ></app-deeplink-button>
              <div class="note">
                {{ "basicInfo.buttonNoteFirstPart" | translate }}
                <a [href]="tosLink" class="link" target="_blank">
                  {{ "basicInfo.terms" | translate }}
                </a>
                {{ "basicInfo.buttonNoteSecondPart" | translate }}
              </div>
            </div>
            
          </div>
        </ng-container>
          
        <ng-template #abortedBlock>
          <div>
            {{ error }}
            <div actions class="navigationButtons">
              <app-deeplink-button
                (buttonClicked)="restartFlow()"
                mat-flat-button
                [text]="'tmidentify.restartFlow'"
                [fullWidth]="true"
                [icon]="'none'"
              ></app-deeplink-button>
            </div>
          </div>
        </ng-template>

      </div>

    </div>
    <div right-content>
      <app-contact></app-contact>
    </div>
  </app-card>
</div>
